<template>
  <div class="logindiv">
    <div class="logo">
      <img alt="logo" src="@/assets/LOGO-MZIE-SLO-2-BARVEN.svg" height="60">
    </div>
    <div class="success-message">
      <h2>{{ translated('passChanged') }}</h2>      
    </div>
    <div class="grid submitbutton">
        <div class="col-12 donthaveaccount">
            <Button :label="translated('backtologin')" @click="goToLogin" />
        </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import router from "@/router";

export default {
  data() {
    return {
      translated: computed(() => 
        typeof this.$store !== 'undefined' && this.$store.getters.getTranslate 
          ? this.$store.getters.getTranslate 
          : (key) => key // fallback
      )
    }
  },
  methods: {
    goToLogin() {
      router.push("login");
    }
  },
  mounted() {
    setTimeout(() => {
    //   this.goToLogin();
    }, 5000); // Redirect after 5 seconds
  }
}
</script>

<style scoped>
.donthaveaccount {
  text-align: center;
  cursor: pointer;
}

.logindiv .logo {
  padding: 10px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}
.success-message {
  text-align: center;
  margin: 40px 0 20px 0;
}
.submitbutton {   
  display: flex;
  justify-content: center;
  margin-top: 60px;
}
</style>